import type { Order } from '@/types/order';

export const SEED_ORDERS: Order[] = [
  {
    id: 'o1',
    productTitle: '500 Stars',
    productCategory: 'stars',
    recipient: { type: 'self' },
    amountLabel: '$8.99',
    createdAt: '2026-07-12T10:00:00.000Z',
    status: 'completed',
  },
  {
    id: 'o2',
    productTitle: 'Premium · 3 months',
    productCategory: 'premium',
    recipient: { type: 'gift', username: 'nika' },
    amountLabel: '$13.99',
    createdAt: '2026-06-30T10:00:00.000Z',
    status: 'completed',
  },
  {
    id: 'o3',
    productTitle: '100 Stars',
    productCategory: 'stars',
    recipient: { type: 'self' },
    amountLabel: '$1.89',
    createdAt: '2026-06-18T10:00:00.000Z',
    status: 'processing',
  },
];

export const SEED_BALANCE = 1240;
